<template>
    <div class="production-view" :class="[$mq]">
        <!-- <FryerStates :fryers="fryers" :debug="debug" :productsCooking="productsCooking" /> -->
        <div class="main-content" :class="{ 'cooking-collapsed': cookingCollapsed }">
            <div class="plk-pending">
                <div class="header">
                    <span>{{ $t('production.plk.view.pending') }} ({{ products.length }})</span>
                    <span class="debug" v-if="debug">
                        <i class="i-andy-menu-help i-andy-m" @click="debugProducts = !debugProducts"></i>
                    </span>
                </div>
                <PendingToMake 
                    :products="products" 
                    @addProduct="addProduct" 
                    :debug="debugProducts"
                    :productsCooking="productsCooking"
                />
            </div>
            <div class="plk-cooking" :class="{ 'has-footer': hasSelectedProducts, 'cooking-collapsed': cookingCollapsed }">
                <div class="header">
                    <span class="toggle-collapse clickable" @click="toggleCookingCollapse" :title="cookingCollapsed ? $t('production.plk.view.expand') : $t('production.plk.view.collapse')">
                        <i :class="cookingCollapsed ? 'i-andy-chevron-left i-andy-m' : 'i-andy-chevron-right i-andy-m'"></i>
                    </span>
                    <p v-if="!cookingCollapsed">{{ $t('production.plk.view.cooking') }} ({{ safeProductsCooking.length }})</p>
                    <span v-if="!cookingCollapsed" class="add-product" @click="addProductPopup">
                        <i class="i-andy-add i-andy-l"></i>
                    </span>
                </div>
                <div class="content" :class="{ 'no-cooking': safeProductsCooking.length === 0, 'collapsed': cookingCollapsed }" :style="cookingCollapsed ? {} : {'grid-template-rows': `repeat(${fryers.length}, 1fr)`}">
                    <template v-if="safeProductsCooking.length === 0">
                        <div class="no-cooking clickable" v-for="fryer in fryers" :key="`empty-cooking-${fryer.id}`" @click="toggleFryer(fryer.id)" :class="{ 'available': fryer.status === 1, 'unavailable': fryer.status === -1, 'collapsed': cookingCollapsed }">
                            <i class="i-andy-pan i-andy-m"></i>
                            <template v-if="!cookingCollapsed">
                                <p v-if="fryer.status === 1">{{ $t('production.plk.view.not-cooking') }}</p>
                                <p v-else-if="fryer.status === -1">{{ $t('production.plk.fryers.state.unavailable') }}</p>
                                <small>{{ fryer.status === 1 ? $t('production.plk.fryers.click-to-toggle-to-unavailable') : $t('production.plk.fryers.click-to-toggle-to-available') }}</small>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <CookingCard 
                            v-for="product in safeProductsCooking" 
                            :key="`cooking-${product.id}-${product.fryerId || 'no-fryer'}-${product.batch_id || 'no-batch'}`" 
                            :product="product"
                            :collapsed="cookingCollapsed"
                            @cookingCompleted="onCookingCompleted"
                        />
                        <div class="no-cooking clickable" v-for="(fryer, index) in allFryersAvailable" :key="`available-cooking-${index}`" @click="toggleFryer(fryer.id)" :class="{ 'available': fryer.status === 1, 'unavailable': fryer.status === -1, 'collapsed': cookingCollapsed }">
                            <i class="i-andy-pan i-andy-m"></i>
                            <template v-if="!cookingCollapsed">
                                <p v-if="fryer.status === 1">{{ $t('production.plk.view.not-cooking') }}</p>
                                <p v-else-if="fryer.status === -1">{{ $t('production.plk.fryers.state.unavailable') }}</p>
                                <small>{{ fryer.status === 1 ? $t('production.plk.fryers.click-to-toggle-to-unavailable') : $t('production.plk.fryers.click-to-toggle-to-available') }}</small>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="footer" v-if="hasSelectedProducts && !cookingCollapsed">
                    <div class="delete-selected" @click="deleteSelected(selectedProducts)">
                        <i class="i-andy-error-fill i-andy-m"></i>
                        <span>{{ $t('production.plk.view.finalize') }} ({{ selectedProducts.length }})</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FryerStates from './fryerStates.vue'
import PendingToMake from './pendingToMake.vue'
import CookingCard from './cookingCard.vue'
const COOKING_COLLAPSED_STORAGE_KEY = 'pls-stock-production-cooking-collapsed'

export default {
    name: 'ProductionView',
    components: {
        FryerStates,
        PendingToMake,
        CookingCard
    },
    props: {
        products: { type: Array, default: () => [] },
        productsCooking: { 
            type: Array, 
            default: () => [],
            validator: function(value) {
                return Array.isArray(value)
            }
        },
        //fryers: { type: Array, default: () => [] },
        sidebarExpanded: { type: Boolean, default: false },
        debug: { type: Boolean, default: false }
    },
    data() {
        return {
            debugProducts: false,
            cookingCollapsed: false,
        }
    },
    created() {
        this.cookingCollapsed = this.loadCookingCollapsedFromStorage()
    },
    computed: {
        safeProductsCooking() {
            return Array.isArray(this.productsCooking) ? this.productsCooking : []
        },
        selectedProducts() {
            const selectedProducts = this.$store.getters['production/getSelectedCookingProducts']
            return selectedProducts
        },
        hasSelectedProducts() {
            return this.selectedProducts.length > 0
        },
        productsList(){
            const products = this.$store.getters['production/getProducts']
            return Object.entries(products).reduce((acc, [key, value]) => {
                if(value.id && value.type == 6 && value.status){
                    acc[value.id] = value
                }
                return acc
            }, {})
        },
        fryers(){
            const fryers = this.$store.getters['production/getFryers']
            if(!fryers) return [];
            return fryers
        },
        allFryersAvailable() {
            const fryersUnavailable = this.fryers.filter(fryer => fryer.status === -1)
            const fryersAvailable = this.fryers.filter(fryer => fryer.status === 1)
            return [...fryersUnavailable, ...fryersAvailable]
        },
    },
    methods: {
        loadCookingCollapsedFromStorage() {
            try {
                const stored = localStorage.getItem(COOKING_COLLAPSED_STORAGE_KEY)
                return stored === '1' || stored === 'true'
            } catch {
                return false
            }
        },
        saveCookingCollapsedToStorage(value) {
            try {
                localStorage.setItem(COOKING_COLLAPSED_STORAGE_KEY, value ? '1' : '0')
            } catch {
                // Ignorar si localStorage no está disponible
            }
        },
        toggleCookingCollapse() {
            this.cookingCollapsed = !this.cookingCollapsed
            this.saveCookingCollapsedToStorage(this.cookingCollapsed)
        },
        toggleFryer(id) {
                //To enable or disable the fryer
            const fryers = JSON.parse(JSON.stringify(this.fryers))
            fryers.forEach(fryer => {
                if(fryer.id == id && fryer.status != 2){
                    fryer.status = fryer.status == 1 ? -1 : 1
                }
            })

            this.$store.commit('production/setFryers', fryers)
            this.$store.dispatch('production/toggleFryer', fryers)
        },
        addProduct(product, callback) {
            this.$emit('addProduct', product, callback)
        },  
        onCookingCompleted(product) {
            this.$emit('cookingCompleted', product)
        },
        deleteSelected(products) {
            this.$emit('deleteSelected', products)
        },
        getAvailableFryer() {
            return this.fryers.find(fryer => fryer && fryer.status === 1)
        },
        addProductPopup() {
            // Verificar si hay huecos disponibles para cocinar
            // Verificar si hay freidoras disponibles
            const availableFryer = this.getAvailableFryer()
            if (!availableFryer) {
                // No hay freidoras disponibles
                    this.$popup.messageNewDesing({
                        title: this.$t('production.plk.fryers.popup.not-available.title'),
                        message: this.$t('production.plk.fryers.popup.not-available.message'),
                        textSave: this.$t('production.plk.fryers.popup.not-available.button')
                    })
                    
                return
            }

            this.$popup.plsAddProduct({
                data: {
                    productsList: this.productsList
                },
                onSave: (value) => {
                    const product = this.productsList[value.product.id]
                    if (!product) return

                    // 1. Agregar producto a la lista de cocinando inmediatamente (actualización optimista)
                    const now = moment()
                    const readyDate = now.clone().add(product.cooking_time, 'minutes')
                    const batchId = `temp_${Date.now()}` // ID temporal hasta que la API responda
                    
                    const cookingProduct = {
                        id: `${value.product.id}_cooking_${Date.now()}`,
                        batch_id: batchId,
                        reference_id: value.product.id,
                        name: product.name,
                        quantity: value.quantity,
                        addedAt: now.format('YYYY-MM-DD HH:mm:ss'),
                        startTime: now.format('YYYY-MM-DD HH:mm:ss'),
                        created_date: now.format('YYYY-MM-DD HH:mm:ss'),
                        ready_date: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                        estimatedEndTime: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                        duration: product.cooking_time,
                        time: product.cooking_time,
                        status: 'cooking'
                    }
                    
                    this.$store.commit('production/addCookingProduct', cookingProduct)
                    //Actualizar el estado de la freidora
                    const fryerId = availableFryer.id
                    this.$store.commit('production/updateFryerStatus', {
                        fryerId: fryerId,
                        status: 2
                    })
        
                    // 2. Petición a la API en segundo plano
                    this.$store.dispatch('production/addBatch', {
                        reference_id: value.product.id,
                        quantity: value.quantity,
                        business_date: moment().format('YYYY-MM-DD'),
                        recommended_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                        ready_date: readyDate.format('YYYY-MM-DD HH:mm:ss'),
                        created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                        data: JSON.stringify({
                            user_created: 1
                        }),
                        status: 1,
                        offline: 0,
                    }).then(response => {
                        // 3. Actualizar el batch ID temporal con el real cuando la API responda
                        if (response && response.data && response.data.id) {
                            this.$store.commit('production/editCookingBatch', {
                                temporalBatchId: batchId,
                                originalBatchId: response.data.id,
                            })
                        }
                    }).catch(error => {
                        // 4. En caso de error, revertir cambios optimistas
                        console.error('Error al agregar producto:', error)
                        this.$store.commit('production/removeCookingProduct', cookingProduct.id)
                        
                        this.$snackbar.error({
                            message: 'Error al agregar el producto. Los cambios se han revertido.',
                            closeable: true,
                            timeout: 5000
                        })
                    })
                }
            })
        }
    }
}


</script>

<style lang="scss" scoped>
.production-view {
    grid-area: production-view;
    height: 100%;
    max-height:100%;
    overflow: hidden;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    grid-template-areas:
        "main-content";

    .main-content {
        grid-area: main-content;
        height: 100%;
        width: 100%;
        display: grid;
        gap: 8px;
        padding: 16px;

        grid-template-columns: 2fr 1fr;
        grid-template-rows: 1fr;
        grid-template-areas:
            "plk-pending cooking";

        &.cooking-collapsed {
            grid-template-columns: 1fr 80px;
        }

        .plk-pending {
            grid-area: plk-pending;
            height: 100%;
            border-radius: 4px;
            overflow: hidden;

            .header {
                background-color: $color-neutral-300;
                padding: 8px;
                width: 100%;
                @include display-flex();
                @include justify-content(center);

                span {
                    font-family: $text-bold;
                    @include font-size(24px);
                }

                .debug {
                    cursor: pointer;

                    i[class^="i-andy-"] {
                        color: $color-success-500;
                    }
                }
            }


        }

        .plk-cooking {
            grid-area: cooking;
            height: 100%;
            border-radius: 4px;
            display: grid;
            grid-template-rows: 62px 1fr;
            grid-template-areas:
                "header"
                "content";
            max-height: 90vh;
            min-height: 90vh;
            overflow: hidden;
            transition: min-width 0.25s ease, width 0.25s ease;

            &.cooking-collapsed {
                min-width: 80px;
                max-width: 80px;
            }

            &.has-footer {
                grid-template-rows: 62px 1fr 62px;
                grid-template-areas:
                    "header"
                    "content"
                    "footer";

                
            }

            &.cooking-collapsed .header {
                @include justify-content(center);
            }

            .header {
                grid-area: header;
                background-color: $color-neutral-300;
                padding: 8px;
                width: 100%;
                @include display-flex();
                @include justify-content(space-between);
                @include align-items(center);

                $btn-add-size: 54px;

                .toggle-collapse {
                    width: 40px;
                    min-width: 40px;
                    height: 40px;
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    border-radius: 4px;
                    cursor: pointer;

                    i[class^="i-andy-"] {
                        color: $color-neutral-500;
                    }

                    &:hover i[class^="i-andy-"] {
                        color: $color-neutral-600;
                    }
                }

                >p {
                    width: 100%;
                    font-family: $text-bold;
                    @include font-size(24px);
                    text-align: center;
                }

                .add-product {
                    width: $btn-add-size;
                    height: $btn-add-size;
                    min-width: $btn-add-size;
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    border-radius: 4px;
                    background-color: $color-success-500;
                    cursor: pointer;

                    i {
                        color: $color-white;
                    }
                }

            }

            .content {
                grid-area: content;
                width: 100%;
                min-height: 0;
                /* @include display-flex();
                @include align-items(flex-start);
                @include justify-content(flex-start);
                @include flex-direction(column); */
                display: grid;
                grid-template-columns: 1fr;
                gap: 8px;
                background-color: $color-white;
                padding: 16px;
                overflow-y: auto;

                &.collapsed {
                    grid-auto-rows: 1fr;
                    padding: 8px;
                    gap: 6px;
                    min-width: 0;
                }

                .no-cooking {
                    @include display-flex();
                    @include flex-direction(column);
                    @include align-items(flex-start);
                    @include justify-content(center);
                    border-radius: 4px;
                    border: 1px solid $color-neutral-300;
                    transition: all 0.2s ease;
                    padding: 16px;

                    &.collapsed {
                        @include align-items(center);
                        @include justify-content(center);
                        padding: 8px;
                        min-height: 0;
                        height: 100%;
                    }

                        

                    i[class^="i-andy-"] {
                        color: $color-neutral-500;
                        padding: 8px;
                    }

                    p {
                        font-family: $text;
                        @include font-size(18px);
                        text-align: left;
                        padding:0 8px;
                        margin-bottom: 4px;
                    }

                    small {
                        font-family: $text;
                        @include font-size(12px);
                        padding:0 8px;
                    }

                    // Estado disponible (status 1)
                    &.available {
                        background-color: $color-success-100;
                        
                        i[class^="i-andy-"] {
                            color: $color-success-500;
                        }

                        p {
                            font-family: $text-bold;
                            color: $color-success-800;
                        }

                        small {
                            color: $color-success-800;
                        }
                    }

                    // Estado no disponible (status -1)
                    &.unavailable {
                        background-color: $color-error-100;
                            
                        i[class^="i-andy-"] {
                            color: $color-error-500;
                        }

                        p {
                            font-family: $text-bold;
                            color: $color-error-800;
                        }

                        small {
                            color: $color-error-800;
                        }
                    }

                    // Cursor pointer para freidoras que se pueden hacer clic
                    /* &.clickable {
                        cursor: pointer;

                        &:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

                            &.available {
                                border-color: $color-success-800;
                                background-color: $color-success-100;

                                .icon{
                                    border: solid 1px $color-success-500;
                                }
                            }

                            &.unavailable {
                                border-color: $color-error-800;
                                background-color: $color-error-100;
                                .icon{
                                    border: solid 1px $color-error-500;
                                }
                            }
                        }
                    } */
                }

                
            }

            .footer {
                height: 62px;
                background-color: $color-neutral-300;
                padding: 8px;
                width: 100%;
                @include display-flex();
                @include justify-content(flex-end);
                @include align-items(center);

                .delete-selected {
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    gap: 8px;
                    background-color: $color-error-500;
                    border-radius: 4px;
                    padding: 8px;
                    cursor: pointer;

                    i[class^="i-andy-"] {
                        color: $color-white;
                    }

                    span {
                        font-family: $text-bold;
                        @include font-size(24px);
                        color: $color-white;
                    }
                }
            }
        }
    }

    /* PLS SIZES MONITORS*/
    &.landscape {
        .main-content {
            grid-template-columns: 1.5fr 1fr;

            &.cooking-collapsed {
                grid-template-columns: 1fr 80px;
            }
            .plk-pending {
                .header{
                    padding: 4px;
                    span{
                        @include font-size(20px);
                    }
                }
            }
            .plk-cooking {
                .header{
                    padding: 4px;
                    >p{
                        @include font-size(20px);
                    }
                    .add-product{
                        width: 48px;
                        height: 48px;
                        min-width: 48px;
                    }
                }

                .content{
                    .no-cooking{
                        p{
                            @include font-size(14px);
                        }
                        small{
                            @include font-size(12px);
                        }
                    }
                }

                .footer{
                    .delete-selected{
                        span{
                            @include font-size(20px);
                        }
                    }
                }
            }
        }
    }
}
</style>